import * as yup from 'yup';

import { validateOnlyLettersAndNumber, validatePostcode } from 'app/utils/validations';

const companyDetailsFormSchema = yup.object().shape({
  name: yup.string().required('Company name is mandatory'),
  displayName: yup.string(),
  companyNumber: yup
    .string()
    .required('Company number is mandatory')
    .test(
      'Invalid company number',
      'Company number should only contain letters or numbers',
      (value) => !value || validateOnlyLettersAndNumber(value)
    ),
  addressLine1: yup.string().required('Address line 1 is mandatory'),
  city: yup
    .string()
    .required('Town/City is mandatory')
    .min(2, 'City should contain at least 2 letters')
    .matches(/^[a-zA-ZÀ-ÿ\s'.-]+$/, "City should only contain letters, spaces, and symbols (.-')"),
  countryCode: yup.string().required('Country is mandatory'),
  postcode: yup
    .string()
    .required('Postcode is mandatory')
    .test('Invalid postcode', 'Enter a valid postcode', (value, context) => {
      return validatePostcode(value, context.parent.countryCode);
    }),
  feeGroup: yup.string().required('FX fee group is mandatory'),
  type: yup.string().required('Company type is mandatory'),
  partnerId: yup.string().optional(),
});

export default companyDetailsFormSchema;
